/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseObjectType from './BaseObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * The physical metadata object. <p>Java class for physicalObjectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="physicalObjectType"&gt; &lt;complexContent&gt; &lt;extension base="{}baseObjectType"&gt; &lt;sequence&gt; &lt;element name="name" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="description" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hidden" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="originalName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class PhysicalObjectType extends BaseObjectType{

	name = null;

	description = null;

	hidden = null;

	originalName = null;



	/**
	 * Gets the value of the name property.
	 * @return {String} possible object is {@link String}
	 */
	getName() {
		return this.name;
	}

	/**
	 * Sets the value of the name property.
	 * @param {String} value allowed object is {@link String}
	 */
	setName(value) {
		var oldValue = this.name;
		this.name = value;
		this._setAndNotify(125, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the description property.
	 * @return {String} possible object is {@link String}
	 */
	getDescription() {
		return this.description;
	}

	/**
	 * Sets the value of the description property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDescription(value) {
		var oldValue = this.description;
		this.description = value;
		this._setAndNotify(126, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the hidden property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isHidden() {
		return this.hidden;
	}

	/**
	 * Sets the value of the hidden property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setHidden(value) {
		var oldValue = this.hidden;
		this.hidden = value;
		this._setAndNotify(127, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the originalName property.
	 * @return {String} possible object is {@link String}
	 */
	getOriginalName() {
		return this.originalName;
	}

	/**
	 * Sets the value of the originalName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setOriginalName(value) {
		var oldValue = this.originalName;
		this.originalName = value;
		this._setAndNotify(128, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>PhysicalObjectType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> PhysicalObjectType</code> object from.
	 * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createPhysicalObjectType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "PhysicalObjectType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 125, "name", null));
		featureList.push(this.createFeature(false, false, false, 126, "description", null));
		featureList.push(this.createFeature(false, false, false, 127, "hidden", null));
		featureList.push(this.createFeature(false, false, false, 128, "originalName", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 125:
			this.setName((value));
			break;
		case 126:
			this.setDescription((value));
			break;
		case 127:
			this.setHidden((value));
			break;
		case 128:
			this.setOriginalName((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 125:
			return this.getName();
		case 126:
			return this.getDescription();
		case 127:
			return this.isHidden();
		case 128:
			return this.getOriginalName();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 125:
			return this.getName();
		case 126:
			return this.getDescription();
		case 127:
			return this.isHidden();
		case 128:
			return this.getOriginalName();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/PhysicalObjectType.js